export const UTILITIES_PERSIST_KEY = "Reports-utilities";

export const TRACKING_EVENT_TIME_FRAME =
  "Selected Time Frame (Performance Reports)";
export const TRACKING_EVENT_ORDER_BY = "Chart - Clicked OrderBy";

export const TIMEFRAME_PERSIST_PROP = "timeFrameOption-utilities";
